export default __webpack_public_path__ + "notification.aa8f8c40.mp3";